import styled from "styled-components";
import { T } from "./Theme";

export const CircleStyled = styled.div`
  .circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: ${T.gray};
    display: flex;
    justify-content: center;
    align-items: center;

    font-weight: 500;
    font-size: 20px;
    text-align: center;
    color: #FFFFFF;
  }

  .circleNormal {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: ${T.gray};
    display: flex;
    justify-content: center;
    align-items: center;

    font-weight: 500;
    font-size: 20px;
    text-align: center;
    color: #000000;
  }

  .active {
    background-color: ${T.blue};
  }
`;
